export default "__VITE_ASSET__BDHArH3G__"